import React from 'react'

import { days } from '.'
import EditPostContainer, {
  CommonContainerProps
} from 'containers/EditPostContainer'
import CheckboxForm from 'components/CheckboxForm'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
  availability: Array<number>
}

interface AvailabilityProps extends CommonContainerProps<SelectionType> {
  initAvailability?: Array<number>
  isNextAvailable: boolean
}

// ['Tue'] -> [0, 1, 0, 0...]
const convertAvailabilityForBackend = (displayed: Array<string>) => {
  const toReturn = [0, 0, 0, 0, 0, 0, 0]
  for (const day of displayed) {
    const index = days.findIndex(value => day === value)
    toReturn[index] = 1
  }
  return toReturn
}

// [0, 1, 0 ...] -> ['Tue']
const covertAvailabilityForFrontend = (backend: Array<number>) => {
  const toDisplay: Array<string> = []
  ;(backend || []).forEach((day: number, index: number) => {
    if (day) {
      toDisplay.push(days[index])
    }
  })
  return toDisplay
}

export default class Availability extends React.Component<AvailabilityProps> {
  state: {
    selectedDays: Array<string>
  } = {
    selectedDays: covertAvailabilityForFrontend(
      this.props.initAvailability as Array<number>
    )
  }

  render() {
    return (
      <EditPostContainer
        title='Availability'
        progressValue={36}
        {...this.props}
        onNext={() => {
          return this.props.onNext({
            availability: convertAvailabilityForBackend(this.state.selectedDays)
          })
        }}
        isNextAvailable={this.state.selectedDays.length > 0}
      >
        {this.state.selectedDays.length === 0 && (
          <ErrorText>Select one or more days to continue</ErrorText>
        )}
        <CheckboxForm
          options={days}
          onSelect={selectedDays => {
            this.setState({ selectedDays })
          }}
          selected={this.state.selectedDays}
        />
      </EditPostContainer>
    )
  }
}
